(function(){
    'use strict'

    angular
    .module('app.tiposAccionPersonal')
    .controller('EditarTipoAccionPersonal', EditarTipoAccionPersonal);

    EditarTipoAccionPersonal.$inject = ['$scope', '$q', '$animationsSrv', '$routeParams', 'TiposAccionPersonalService', 'CantidadesService', 'logger', '$location', 'UserInfoService', 'CoreSrv'];

    function EditarTipoAccionPersonal($scope, $q, $animationsSrv, $routeParams, TiposAccionPersonalService, CantidadesService, logger, $location, UserInfoService, CoreSrv) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.cantidades = [];

        vm.tipoAccionPersonal = {
            descripcion: '',
            prefijo: '',
            mostrarFechasEnReportes: false,
            cantidadId: -1
        };

        vm.tipoAccionPersonalId = $routeParams.id ? $routeParams.id : 0;

        var promiseCantidades = getCantidades();

        cargarTipoAccionPersonal();

        function cargarTipoAccionPersonal(){
            $q.all([promiseCantidades]).then(getById);
        }

        function getById(){

            if(vm.tipoAccionPersonalId != 0){
                TiposAccionPersonalService.getById(UserInfoService.getCompaniaId(), vm.tipoAccionPersonalId)
                .then(function(tipoAccionPersonal){
                    tipoAccionPersonal.cantidadId = tipoAccionPersonal.cantidadId == null ? -1 : tipoAccionPersonal.cantidadId;
                    vm.tipoAccionPersonal = tipoAccionPersonal;
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del Tipo de Accion de Personal')
                });
            }
        }

        function getCantidades(){
            var promise = CantidadesService.getAll()
            .then(function(cantidades){
                vm.cantidades = cantidades.sort(CoreSrv.dynamicSort("descripcion"));
            })
            .catch(function(error){
                $logger.error('Error al obtener las cantidades.');
            }); 
            
            return promise;
        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.tipoAccionPersonalForm.$valid){
                if(!vm.tipoAccionPersonal.id){
                    vm.tipoAccionPersonal.id = 0;
                    saveTipoAccionPersonal();
                }
                else{
                    if($scope.tipoAccionPersonalForm.$dirty){
                        updateTipoAccionPersonal();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function saveTipoAccionPersonal() {
            var promise = TiposAccionPersonalService.save(vm.tipoAccionPersonal);
                
            promise
            .then(function(response){
                logger.success('Tipo de de Acción de Personal creado con éxito.');
                clearTipoAccionPersonalData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(`Hubo un erro al crear el tipo de de Acción de Personal: ${error.data.Message}`);
                        break;  
                    default:
                        logger.error('Hubo un erro al crear el tipo de Acción de Personal');
                        break;
                }
            }); 
        }

        function updateTipoAccionPersonal() {
            var promise = TiposAccionPersonalService.update(vm.tipoAccionPersonal);
                
            promise
            .then(function(response){
                logger.success('Tipo de Acción de Personal modificado con éxito.');
                $location.path('/tipos-accion-personal');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(`Hubo un erro al modificar el tipo de de Acción de Personal: ${error.data.Message}`);
                        break;  
                    default:
                        logger.error('Hubo un erro al modificar el tipo de Acción de Personal');
                        break;
                }
            }); 
        }

        function clearTipoAccionPersonalData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.tipoAccionPersonal = {
                descripcion: '',
                prefijo: '',
                mostrarFechasEnReportes: false,
                cantidadId: -1
            };
            // Set back to pristine.
            $scope.tipoAccionPersonalForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.tipoAccionPersonalForm.$setUntouched();
        }

    }
})();